import { createAdminV2Error } from '@/admin-v2/foundation/errors';

type RequiredImageInputParams = {
  normalizedInput: Record<string, unknown>;
  fieldId: string;
  errorCode: string;
  message: string;
};

function imageInputError(params: RequiredImageInputParams) {
  return createAdminV2Error({
    code: params.errorCode,
    message: params.message,
    fieldPath: `input.${params.fieldId}`,
    status: 422,
  });
}

export function resolveAdminV2RequiredImageList(
  params: RequiredImageInputParams
) {
  const value = params.normalizedInput[params.fieldId];
  if (typeof value === 'string' && value.trim().length > 0) {
    return [value];
  }
  if (
    Array.isArray(value) &&
    value.length > 0 &&
    value.every((item) => typeof item === 'string' && item.trim().length > 0)
  ) {
    return value;
  }
  throw imageInputError(params);
}

export function resolveAdminV2RequiredSingleImage(
  params: RequiredImageInputParams
) {
  const values = resolveAdminV2RequiredImageList(params);
  if (values.length === 1) return values[0];
  throw imageInputError(params);
}
